import React, { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api/client'

export default function ResendVerifyEmail() {
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState(() => searchParams.get('email') || '')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await api.post('/auth/resend-verify-email', { email })
      setSent(true)
    } catch (err) {
      setError(err?.message || 'Anfrage fehlgeschlagen.')
    } finally {
      setLoading(false)
    }
  }

  if (sent) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
        <div className="card-glass w-full max-w-md p-6 sm:p-8">
          <div className="flex justify-center" aria-hidden>
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500 to-pink-500 text-2xl font-bold shadow-glow">◇</div>
          </div>
          <h1 className="mt-6 text-center text-2xl font-bold text-white">
            <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">E-Mail gesendet</span>
          </h1>
          <p className="mt-4 text-center text-white/80">
            Falls ein Konto mit dieser E-Mail existiert und noch nicht bestätigt ist, wurde ein neuer Aktivierungslink gesendet. Bitte Posteingang (und Spam) prüfen.
          </p>
          <p className="mt-6 text-center">
            <Link to="/login" className="text-violet-300 hover:underline">Zurück zur Anmeldung</Link>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
      <div className="card-glass w-full max-w-md p-6 sm:p-8">
        <div className="flex justify-center" aria-hidden>
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500 to-pink-500 text-2xl font-bold shadow-glow">◇</div>
        </div>
        <h1 className="mt-6 text-center text-2xl font-bold text-white">
          <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">Aktivierungslink erneut senden</span>
        </h1>
        <p className="mt-2 text-center text-white/60">E-Mail eingeben – wir senden einen neuen Aktivierungslink (gültig 48 Stunden).</p>
        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          {error && (
            <div role="alert" className="rounded-xl border border-red-500/40 bg-red-500/15 px-4 py-3 text-sm font-medium text-red-200">
              {error}
            </div>
          )}
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-white/80">E-Mail</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/40 focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20"
              placeholder="name@beispiel.de"
            />
          </label>
          <button type="submit" className="btn-gradient w-full min-h-[48px] py-3 text-base" disabled={loading}>
            {loading ? 'Bitte warten…' : 'Link erneut senden'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-white/70">
          <Link to="/login" className="text-violet-300 hover:underline">Zurück zur Anmeldung</Link>
        </p>
      </div>
    </div>
  )
}
